import request from 'superagent';
import { setCustomer } from './customer';
import { setComputedCart } from './computed_cart';
import { addToCartO, removeFromCartO, MAX_CART_ITEM, updateQuantity } from '../shared/cart';
import { createCookie, getCookie, getEnrollCartProductIds, createEnrollCartCookie } from '../shared/cookie.js';
import { setFeedback, delayedClearFeedback } from './feedback';
import { openMiniCartModal } from '../modules/active_modal';
import { navigate } from './high_level_actions';

export function checkIfProductInStore(oProduct, genres, categories, featured) {
  let genreFound = false,
      categoryFound = false,
      featuredFound = false,
      pGenres = oProduct.genres,
      pCategories = oProduct.categories;
  genreFound = pGenres.find( x => genres.find( g => g.id === ( x.id || x )) ) ? true : false;
  categoryFound = pCategories.find( x => categories.find( c => c.id === ( x.id || x )) ) ? true : false;
  featuredFound = featured.find( x => x.id == oProduct.id ) ? true : false;
  return genreFound || categoryFound || featuredFound;
}

export function addEnrollProductToCart(oProduct, quantity=1 ) {
  return (dispatch, getState) => {
    // Make sure product is in this store
    if (!checkIfProductInStore(oProduct, getState().genres, getState().categories, getState().featured)) {
      console.warn('No store match found for product id ' + oProduct.id + '.');
      return dispatch([
        setFeedback("This product isn't in this club."),
        delayedClearFeedback()
      ]);
    }

    if(oProduct.excludeFromPromos || oProduct.format === "bluray" ){
      return dispatch([
        setFeedback("This product is not available for enrollment orders."),
        delayedClearFeedback()
      ]);
    }
    // Get enrollCart values
    let aEnrollCart = getEnrollCartProductIds();
    let currentCartLength = aEnrollCart.filter( x => x ).length;
    let nCartIndex = ( aEnrollCart[0] === null ) ? 0 : 1; //Check to see which position is available; set key accordingly

    if(quantity > 2){
      return dispatch([
        setFeedback("You cannot place more then 2 books in your cart."),
        delayedClearFeedback()
      ]);
    } else if( quantity === 2 && currentCartLength > 0 ){
      return dispatch([
        setFeedback("You can only add one more catalog item to your cart."),
        delayedClearFeedback()
      ]);
    } else if( quantity === 2 && currentCartLength === 0 ){
      aEnrollCart = [
        { id: parseInt(oProduct.id, 10), format: oProduct.format },
        { id: parseInt(oProduct.id, 10), format: oProduct.format }
      ];
    } else if( quantity === 1 ){
      aEnrollCart[nCartIndex] = { id: parseInt(oProduct.id, 10), format: oProduct.format };
    }

    // replace featured or catalog item with new item id and update cookie
    createEnrollCartCookie(aEnrollCart);

    let oFakeEvent = {
      preventDefault: () => {/* noop */},
      currentTarget: { pathname: '/catalog' }
    };

    // Checks path to see if an email & name exists as cookies from email capture form
    if (getState().isSoftLoggedIn ) {
      let email     = getCookie('enrollEmail') || null;
      let firstName = getCookie('enrollFirstName') || null;

      // Updates the leads table in db with enroll cart products
      request
        .put('/svc/misc/captureLead/' + email)
        .query({'first_name': firstName})
        .query({'cart1': (aEnrollCart[0] || null)})
        .query({'cart2': (aEnrollCart[1] || null)})
        .query({'source': 'capturedLead'})
        .end((err, res) => {
          if (err || res.statusCode !== 200 ) return console.warn(err);
        });
    }

    // if ids aren't null/undefined, replace with objects from productMap for computeCart
    aEnrollCart.forEach((n, i) => {
      if (n){
        let obj = getState().maps.get('productMap').get(n.id);
        aEnrollCart[i] =  {...obj, format: n.format }
        if(n.format !== 'regular') aEnrollCart[i] =  {...aEnrollCart[i], sale_price: obj[n.format].price, ...obj[n.format] };
      }
    });

    dispatch( setComputedCart(getState().customer, getState().computedCart, aEnrollCart) );

    let cart =  getState().computedCart.items.filter( prod => prod ).map( prod => prod.mmid ).join(',');
    window.dataLayer.push({ 'event': 'addproduct', 'products': cart, 'value': getState().computedCart.total });
  }
}

export function saveEnrollCartCookie(newCart){
  let aEnrollCart = [null, null];
  if (newCart[0]){
    aEnrollCart[0] = {id: newCart[0].id, format: newCart[0].format, quantity: 1 } ;
  }
  if(newCart[0] && newCart[0].quantity > 1){
    aEnrollCart[1] = {id: newCart[0].id, format: newCart[0].format, quantity: 1 } ;
  } else if (newCart[1]){
    aEnrollCart[1] = {id: newCart[1].id, format: newCart[1].format, quantity: 1 } ;
  }
  createEnrollCartCookie(aEnrollCart);
}


export function  removeEnrollItem(nCartIndex) {
  return (dispatch, getState) => {
    // Get enrollCart values
    let aEnrollCart = getEnrollCartProductIds();

    // Clear id from cart array and update cookie
    aEnrollCart[nCartIndex] = null;
    if (aEnrollCart[0] === null){
      aEnrollCart[0] = aEnrollCart[1];
      aEnrollCart[1] = null;
    }
    createEnrollCartCookie(aEnrollCart);

    // if ids aren't null/undefined, replace with objects from productMap for computeCart
    aEnrollCart.forEach((n, i) => {
      if (n){
        let obj = getState().maps.get('productMap').get(n.id);
        aEnrollCart[i] =  {...obj, format: n.format }
        if(n.format !== 'regular') aEnrollCart[i] =  {...aEnrollCart[i], sale_price: obj[n.format].price, ...obj[n.format] };
      }
    });

    dispatch( setComputedCart(getState().customer, getState().computedCart, aEnrollCart) );

    let cart = getState().computedCart.items.filter( prod => prod ).map( prod => prod.mmid ).join(',');
    window.dataLayer.push({ 'event': 'addproduct', 'products': cart, 'value': getState().computedCart.total });
  }
}

export function updateProductCart(oProduct, quantity){
  return (dispatch, getState) => {
    
    let oCart = getState().customer.cart;
    let currentCartLength = oCart.reduce( (a,b) => { return a + ( b? b.quantity: 0 )}, 0);
    let existingQuantity = oCart.find( x => x && x.id == oProduct.id );
    let proposedCartLength = currentCartLength + quantity - (existingQuantity ? existingQuantity.quantity : 0);
    let canAlterQuantity = false;
    let isFeaturedBook = getState().featured.find(e => e.id == oProduct.id );
    let hasBundlePricing = getState().store.bundle_pricing;

    // check for open cart positions
    if (( hasBundlePricing &&
          ( (proposedCartLength < MAX_CART_ITEM && !oCart[0] && !isFeaturedBook) ||
            (proposedCartLength <= MAX_CART_ITEM && (oCart[0] || isFeaturedBook)) )
        ) || ( !hasBundlePricing && proposedCartLength <= MAX_CART_ITEM )) {
      if ( ((oCart[0] && isFeaturedBook) || (isFeaturedBook && quantity > 1)) && hasBundlePricing){
        var exFeedback = 'Sorry, but you can only add one featured item to your box.';
      } else canAlterQuantity = true;
    }

    if( canAlterQuantity ){
      let oCustomer  = getState().customer;
      oCustomer.cart = updateQuantity({ id: oProduct.id, format: oProduct.format, quantity: quantity},
                          getState().customer.cart.map( x => { return x ? { format: x.format === true, quantity: x.quantity, id: x.id } : x }),
                          getState().featured, getState().store.bundle_pricing);

      request
        .put('/svc/cart/update/' + oProduct.id + '/' + oProduct.format + '/' + quantity )
        .end((err, res) => {
          if (err || res.statusCode !== 200) {
            return dispatch([
              setCustomer(res.body),
              setComputedCart(res.body, getState().computedCart, []),
              setFeedback('Could not update ' + oProduct.title + ' quantity.'),
              delayedClearFeedback()
            ]);
          }

          dispatch([
            setCustomer(res.body),
            setComputedCart(res.body, getState().computedCart, [])
          ]);

          let cart =  getState().computedCart.items.filter( prod => prod ).map( prod => prod.mmid ).join(',');
          window.dataLayer.push({ 'event': 'addproduct', 'products': cart, 'value': getState().computedCart.total });
        });
    } else {
      let sFeedback = exFeedback !== undefined ? exFeedback : ( (oCart[0] && hasBundlePricing) || (!hasBundlePricing)
        ? 'You cannot place more than ' + MAX_CART_ITEM + ' items in your box.'
        : 'You cannot place more than ' + (MAX_CART_ITEM - 1) +' catalog items in your box. Add a Featured Selection!');
      dispatch([
        setFeedback(sFeedback),
        delayedClearFeedback()
      ]);
    }
  }
}

export function addProductToCart(oProduct, quantity) {
  return (dispatch, getState) => {
    // Make sure product is in this store
    if (!checkIfProductInStore(oProduct, getState().genres, getState().categories, getState().featured)) {
      console.warn('No store match found for product id ' + oProduct.id + '.');
      return dispatch([
        setFeedback("This product isn't in this club."),
        delayedClearFeedback()
      ]);
    }

    let oCart = getState().customer.cart;
    let currentCartLength = oCart.reduce( (a,b) => { return a + ( b? b.quantity: 0 )}, 0);
    let proposedCartLength = currentCartLength + quantity;
    let bookInCart = oCart.filter( (c) => c && c.id == oProduct.id)[0];
    let bCanAdd = false;
    let isFeaturedBook = getState().featured.find(e => e.id == oProduct.id );
    let hasBundlePricing = getState().store.bundle_pricing ;

    // check for open cart positions
    if ( proposedCartLength <= MAX_CART_ITEM ) {
      if ( ((oCart[0] && isFeaturedBook) || (isFeaturedBook && quantity > 1)) && hasBundlePricing){
        var exFeedback = 'Sorry, but you can only add one featured item to your box.';
      } else if( bookInCart && bookInCart.quantity + quantity > 6 ) {
        var exFeedback = 'Sorry, but you can only add up to 6 of the same title to your cart.';
      } else bCanAdd = true;
    }

    if (bCanAdd) {
      // Optimistically update state right away
      let oCustomer            = getState().customer;
      oCustomer.cart           = addToCartO(oProduct, quantity, getState().customer.cart, getState().featured, getState().store.bundle_pricing);

      dispatch([
        openMiniCartModal(),
        setCustomer( oCustomer ),
        setComputedCart( oCustomer, getState().computedCart, [])
      ]);

      // AJAX call + update state again
      request
        .put('/svc/cart/' + oProduct.id + '/' + oProduct.format + '/' + quantity )
        .end((err, res) => {
          if (err || res.statusCode !== 200) {
            return dispatch([
              setCustomer(res.body),
              setComputedCart(res.body, getState().computedCart, []),
              setFeedback('Could not add ' + oProduct.title + ' to your box.'),
              delayedClearFeedback()
            ]);
          }

          dispatch([
            setCustomer(res.body),
            setComputedCart(res.body, getState().computedCart, [])
          ]);

          let cart =  getState().computedCart.items.filter( prod => prod ).map( prod => prod.mmid ).join(',');
          window.dataLayer.push({ 'event': 'addproduct', 'products': cart, 'value': getState().computedCart.total });
        });

    // if can't add, just give feedback
    } else {
      let sFeedback = exFeedback !== undefined ? exFeedback : ( (oCart[0] && hasBundlePricing) || (!hasBundlePricing)
        ? 'You cannot place more than ' + MAX_CART_ITEM + ' items in your box.'
        : 'You cannot place more than ' + (MAX_CART_ITEM - 1) +' catalog items in your box. Add a Featured Selection!');
      dispatch([
        setFeedback(sFeedback),
        delayedClearFeedback()
      ]);
    }
  }
}

export function removeCartProduct(oProduct) {
  return (dispatch, getState) => {
    // Optimistically update state right away
    let oCustomer            = getState().customer;
    oCustomer.cart           = removeFromCartO(oProduct, getState().customer.cart, getState().featured, getState().store.bundle_pricing);
    dispatch([
      setCustomer( oCustomer ),
      setComputedCart( oCustomer, getState().computedCart, [])
    ]);

    // AJAX call + update state again
    request
      .del('/svc/cart/' + oProduct.id + '/' + oProduct.format )
      .end((err, res) => {
        if (err || res.statusCode !== 200) {
          return dispatch([
            setCustomer(res.body ),
            setComputedCart(res.body, getState().computedCart, []),
            setFeedback('Could not remove ' + oProduct.title + ' from your box.'),
            delayedClearFeedback()
          ]);
        }

        dispatch([
          setCustomer(res.body ),
          setComputedCart(res.body, getState().computedCart, [])
        ]);

        let cart =  getState().computedCart.items.filter( prod => prod ).map( prod => prod.mmid ).join(',');
        window.dataLayer.push({ 'event': 'addproduct', 'products': cart, 'value': getState().computedCart.total });
      });
  }
}



// WEBPACK FOOTER //
// ./src/modules/cart_actions.js